import React from 'react'
import { connect } from 'react-redux'
import { Redirect, Link } from 'react-router-dom'

import { MuiThemeProvider } from '@material-ui/core/styles';

import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import MuiPhoneNumber from 'material-ui-phone-number'

// Custom Inputs
import CustomDialog from './inputs/CustomDialog'
import CustomOutlinedButton from './Mui/CustomOutlinedButton';
import InnerBar from './InnerBar';
import MetaBox from './inputs/MetaBox'
import TextInput from './inputs/TextInput'

import {
  is_logged_on,
  is_validating,
  capitalize,
  theme
} from "../helpers"

 import {
   LocalForm,
   actions
} from 'react-redux-form'

import {
  isRequired,
} from "../validators"

import {
  get_business,
  preferences_index,
  create_business,
  update_business,
  reset_business,
  clear_business,
} from '../actions'

const mapStateToProps = state => {
  const { business, errors, fetching_single, fetched_single, must_redirect } = state.business
  return {
    business,
    errors,
    fetching_single,
    fetched_single,
    must_redirect,
    current_user: state.auth.current_user.data,
    preferences: state.preference.preferences
  }

}

const mapDispatchToProps = dispatch => {
  return {
    getBusiness: business_id => dispatch( get_business(business_id) ),
    createBusiness: values => dispatch( create_business(values) ),
    updateBusiness: (business_id, values) => dispatch( update_business(business_id, values) ),
    getPreferences: () => dispatch( preferences_index() ),
    resetBusiness: () => dispatch( reset_business() ),
    clearBusiness: () => dispatch( clear_business() ),
  };
};

class ConnectedBusinessForm extends React.Component {
  state = {
    actionName: '',
    nameValid: true,
    notesValid: true,

    phone: '',

    formData: null,
    activate: false, // bind to action
    deactivate: false, // bind to action

    showDialog: false,
  }

  attachDispatch(dispatch) {
    this.formDispatch = dispatch;
  }

  checkValid() {
    this.formDispatch( actions.setDirty('business.name') )
    this.formDispatch( actions.setDirty('business.notes') )

    const isValid = this.state.formData.$form.valid
    if (!isValid) {
      window.showSnackbar('error', 'Please fill in all mandatory fields.')
    }
    return isValid
  }

  handleSubmit(inValues) {
    let values = {
      ...inValues
    }
    if (this.state.activate) {
      values={
        ...inValues,
        activate: true,
        index: false
      }
    } else if (this.state.deactivate) {
      values={
        ...inValues,
        deactivate: true,
        index: false
      }
    }

    if (this.state.actionName === "create") {
      this.props.createBusiness(values)
    } else {
      const { business_id } = this.props
      this.props.updateBusiness(business_id, values)
    }
  }

  handleUpdate(form) {
    const { name, notes, phone } = form

    const phoneState = (phone.pristine || phone.valid)

    this.setState({formData: form})

    this.setState({
      nameValid: (name.pristine || name.valid),
      notesValid: (notes.pristine || notes.valid),
    })
  }

  resetView() {
    const { actionName } = this.props
    const { clearBusiness, business, getBusiness } = this.props
    clearBusiness()
    this.setState({ actionName })
    if ( actionName === 'update') {
      const { business_id } = this.props
      if ( business.id !== business_id ) {
        getBusiness(business_id)
      }
    }
  }

  componentWillMount() {
    this.resetView()
  }

  componentDidUpdate(prevProps, prevState) {
    const { timestamp, phone } = this.props.business
    const old_timestamp = prevProps.business.timestamp
    const { actionName } = this.props
    if (this.state.actionName !== actionName ) {
      return this.resetView()
    }
    if ( timestamp !== old_timestamp ) {
      this.setState({
        phone: phone || '',
      })
    }

    if (this.props.must_redirect && !prevProps.must_redirect) {
      window.showSnackbar('success', 'Business has been saved.')
    }
  }

  hideDialog() {
    this.setState({showDialog: false, showDeactivateDialog: false})
  }

  handleActivate() {
    this.props.resetBusiness()
    this.setState({activate: true, deactivate: false, showDialog: false})
    this.formDispatch(actions.submit('business'))
  }

  handleDeactivate() {
    this.props.resetBusiness()
    this.setState({activate: false, deactivate: true, showDeactivateDialog: false})
    this.formDispatch(actions.submit('business'))
  }

  handleOnChange(value) {
    this.formDispatch(actions.change('business.phone',value))
    this.setState({phone: value})
  }

  render() {
    if ( !is_logged_on() && !is_validating() ) {
      return <Redirect to="/" />
    }

    const { role } = this.props.current_user

    if ( role !== 'admin' ) {
      return <Redirect to="/" />
    }

    const { actionName, must_redirect } = this.props

    if ( actionName === 'create' && this.props.must_redirect && this.props.business.id ) {
      return <Redirect to={`/businesses/${this.props.business.id}/edit`} />
    }

    if ( actionName === 'update' && !this.props.business.id ) {
      return ''
    }

      if (must_redirect && this.state.activate) {
      window.showSnackbar('success', 'The business status has changed to: Activateed.')
      return (
        <Redirect to="/businesses" />
      )
    } else if (must_redirect && this.state.deactivate) {
      window.showSnackbar('success', 'The business status has changed to: Deactivated.')
      return (
        <Redirect to="/businesses" />
      )
    }

    const {
      name, notes, active, id, longid,
      address, postcode, city, country, phone, website, email,
      created_at, updated_at
    } = this.props.business

    let initialState
    if (actionName === "create") {
      initialState = {
        name: '',
        notes: '',
        address: '', postcode: '', city: '', country: '', phone: '', website: '', email: '',
      }
    } else {
      initialState = {
        name,
        notes,
        address, postcode, city, country, phone, website, email,
      }
    }

    const actionButtons = (
      <div className="d-flex">
        <CustomOutlinedButton
          className="buttonnoto c-blue align-self-center mr-16"
          disabled={false && !this.state.formValid}
          onClick={e => {
            e.preventDefault()
            this.setState({activate: false, deactivate: false})
            this.checkValid()
            this.formDispatch( actions.submit('business'))
          }}>Save</CustomOutlinedButton>
      </div>
    )

    return (
      <MuiThemeProvider theme={theme}>
        <Grid container spacing={24} justify="space-between">

          <Grid item xs={12} md={ actionName === "create" ? 12 : 8} className={actionName !== "create" ? "will-change9" : ''}>
            <div className="d-flex justify-content-between mb-40">
              <Typography className="fw-bold h4">
                {this.props.headTitle || "Business"}
              </Typography>

              { actionButtons }

            </div>
          </Grid>

          <Grid item xs={12} md={ actionName === "create" ? 12 : 8} className={actionName !== "create" ? "will-change9" : ''}>
            <LocalForm
              model="business"
              className="collection-item"
              initialState={initialState}
              getDispatch={(dispatch) => this.attachDispatch(dispatch)}
              onUpdate={(form) => this.handleUpdate(form)}
              onSubmit = {(values) => this.handleSubmit(values)}
            >

              <Paper use="name" className="mb-24 innerbar">
                <InnerBar text="Business Data" />
                <div className="pl-24 pr-24 pt-24 pb-24">

                  <TextInput
                    id="business-name"
                    model="business.name"
                    required
                    placeholder="Business Name"
                    helperText="Required Field *"
                    error={!this.state.nameValid}
                    validators={{
                      required: (val) => {
                        return isRequired(val)
                      }
                    }}
                  />

                  <TextInput
                    id="business-notes"
                    model="business.notes"
                    placeholder="Notes"
                    error={!this.state.notesValid}
                  />

                </div>
              </Paper>

              <Paper use="name" className="mb-24 innerbar">
                <InnerBar text="Contact Details" />
                <div className="pl-24 pr-24 pt-24 pb-24">

                  <TextInput
                    id="business-address"
                    model="business.address"
                    placeholder="Address"
                    helperText={`Enter address`}
                    active={true}
                    multiline={true}
                  />

                  <TextInput
                    id="business-postcode"
                    model="business.postcode"
                    placeholder="Postal Code"
                    helperText={`Enter Postal Code`}
                  />

                  <TextInput
                    id="business-city"
                    model="business.city"
                    placeholder="City"
                    helperText={`Enter City`}
                  />

                  <TextInput
                    id="business-country"
                    model="business.country"
                    placeholder="Country"
                    helperText={`Enter Country`}
                  />

                  <MuiPhoneNumber
                    onChange={ this.handleOnChange.bind(this) }
                    error={false}
                    value={this.state.phone}
                    helperText={`Enter Phone Number`}
                    placeholder="Phone"
                    inputClass="muiPhoneInput mt-32"
                    preferredCountries={['gr']}
                  />

                  <TextInput
                    id="business-website"
                    model="business.website"
                    placeholder="http://you.website.com"
                    helperText={`Website`}
                    helperText={`Enter Website`}
                  />

                  <TextInput
                    id="business-email"
                    model="business.email"
                    placeholder="Email"
                    helperText={`Enter Email`}
                  />

                </div>
              </Paper>
            </LocalForm>

            <Hidden smDown>
              <div className="d-flex justify-content-end mt-40">
                { actionButtons }
              </div>
            </Hidden>
          </Grid>

          { actionName === "update" && (
            <Grid item xs={12} md={4} className="will-change3">

              <Paper>
                <div className="bg-white">
                  <div className="pt-24 pb-24 pr-24 pl-24">
                    <div className="mb-12 c-black087 body2">
                      <span className="d-inline-block fw-bold min-width-100">Status:</span>{active ? "Active" : "Inactive"}
                    </div>

                    <MetaBox
                      title="ID"
                      value={id}
                    />
                    <MetaBox
                      title="Created on"
                      value={new Date(created_at).toLocaleString()}
                    />
                    { updated_at && (<MetaBox
                      title="Modified on"
                      value={new Date(updated_at).toLocaleString()}
                    />)}
                  </div>
                </div>

                <Divider className="bg-divider" />

                <div className="bg-white">
                  <div className="pt-24 pb-24 pr-24 pl-24">
                  <div className="fw-bold body2">Actions:</div>
                    {
                        !active ? (
                          <Link className="c-black087 body2 d-block mb-8" to='' onClick={e=>{
                              e.preventDefault()
                              if (this.checkValid()) {
                                this.setState({showDialog:true})
                              }
                          }}>Activate Business</Link>
                        ) : (
                          <Link className="c-black087 body2 d-block mb-8" to='' onClick={e=> {
                            e.preventDefault()
                            if (this.checkValid()) {
                              this.setState({showDeactivateDialog:true})
                            }
                          }}>Deactivate Business</Link>
                        )
                      }

                  </div>
                </div>
              </Paper>

              <CustomDialog
                id={`active-dialog`}
                qid={id}
                isopen={this.state.showDialog}
                handleClose={this.hideDialog.bind(this)}
                handleAccept={this.handleActivate.bind(this)}
                fullScreen = {false}
                title={`Activate Business?`}
              >
                Do you want to save changes and active this business?
              </CustomDialog>
              <CustomDialog
                id={`deactivate-dialog`}
                qid={id}
                isopen={this.state.showDeactivateDialog}
                handleClose={this.hideDialog.bind(this)}
                handleAccept={this.handleDeactivate.bind(this)}
                fullScreen = {false}
                title={`Deactivate Business?`}
              >
                Do you want to save changes and deactivate this business?
              </CustomDialog>
            </Grid>
          )}
        </Grid>

      </MuiThemeProvider>
    )
  }
}

const BusinessForm = connect(mapStateToProps, mapDispatchToProps)(ConnectedBusinessForm)
export default BusinessForm



// WEBPACK FOOTER //
// ./src/js/components/BusinessForm.js